module.exports = __webpack_public_path__ + "static/media/graph_mau.2058a98f.png";